import React from 'react'
import { Textarea, type TextareaProps } from '@common/ui'

const TrimmedTextArea = ({ onBlur, ...props }: TextareaProps) => {
  const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const trimmed = event.target.value.trim()
    if (trimmed !== event.target.value) {
      const nativeSetter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value')?.set
      nativeSetter?.call(event.target, trimmed)
      event.target.dispatchEvent(new Event('input', { bubbles: true }))
    }
    onBlur?.(event)
  }
  return <Textarea onBlur={handleBlur} {...props} />
}

TrimmedTextArea.displayName = 'TrimmedTextArea'

export default TrimmedTextArea
